import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import DoneAllOutlinedIcon from '@mui/icons-material/DoneAllOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import LockIcon from '@mui/icons-material/Lock';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import { ReactComponent as DataEntryComplete } from './icons/DataEntryComplete.svg'; //custom icon for legend
import { ReactComponent as DraftStatusIcon } from './icons/DraftStatusIcon.svg'; //custom icon for legend

export const getStatusMatchedIcon = (status: string) => {
  if (status === 'Pending Data Entry') {
    return <InsertDriveFileOutlinedIcon color="disabled" />;
  } else if (status === 'Draft') {
    return <DraftStatusIcon />;
  } else if (status === 'Data Entry Complete') {
    return <DataEntryComplete />;
  } else if (status === 'Data Review Complete') {
    return <SearchOutlinedIcon sx={{ color: '#5073B9' }} />;
  } else if (status === 'Source Data Review Complete') {
    return <CheckOutlinedIcon sx={{ color: '#5073B9' }} />;
  } else if (status === 'Source Data Verification Complete') {
    return <DoneAllOutlinedIcon sx={{ color: '#5073B9' }} />;
  } else if (status === 'CRF Signed') {
    return <TaskOutlinedIcon color="success" />;
  } else if (status === 'CRF Locked') {
    return <LockIcon color="success" />;
  }
};

export const getBadgeClassName = (queryStatus: string | null) => {
  if (queryStatus === null) {
    return '';
  } else {
    if (queryStatus === 'Query for User') {
      return 'badgeUser';
    }
    if (queryStatus === 'Query for Other User') {
      return 'badgeOtherUser';
    }
  }
};
